import { useState } from 'react';
import FeedbackModal from './FeedbackModal';

function FeedbackButton() {
  const [isModalOpen, setIsModalOpen] = useState(false);

  return (
    <>
      {/* Floating feedback button */}
      <button
        type="button"
        onClick={() => setIsModalOpen(true)}
        className="fixed bottom-4 right-4 z-40 w-12 h-12 bg-puzzle-blue text-white rounded-full shadow-lg hover:bg-blue-600 hover:scale-110 transition-all flex items-center justify-center"
        aria-label="Send feedback"
        title="Send feedback"
      >
        {/* Message/feedback icon - can be replaced with custom image */}
        <svg
          className="w-6 h-6"
          fill="none"
          stroke="currentColor"
          viewBox="0 0 24 24"
        >
          <path
            strokeLinecap="round"
            strokeLinejoin="round"
            strokeWidth={2}
            d="M8 12h.01M12 12h.01M16 12h.01M21 12c0 4.418-4.03 8-9 8a9.863 9.863 0 01-4.255-.949L3 20l1.395-3.72C3.512 15.042 3 13.574 3 12c0-4.418 4.03-8 9-8s9 3.582 9 8z"
          />
        </svg>
      </button>

      {/* Feedback modal */}
      {isModalOpen && (
        <FeedbackModal onClose={() => setIsModalOpen(false)} />
      )}
    </>
  );
}

export default FeedbackButton;
